import { ChangeDetectorRef, Directive, inject, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from '@df/api/request/request.service';
import { Checkout } from '@df/checkout/checkout.interfaces';
import { App } from '@df/core/app';
import { routeOverride } from '@df/core/meta/route-override.pipe';
import { Events } from '@df/core/service/event';
import { Status } from '@df/core/status';
import { Nexus } from '@tomandco/nexus-api-types';
import { Subscription } from 'rxjs';

@Directive()
export abstract class CheckoutSuccessComponentDef implements OnInit, OnDestroy {
    subscriptions = new Subscription();

    /**
     * Success data
     */
    @Input()
    data!: Nexus.Api.Checkout.Success.ISuccessData;

    /**
     * Form
     * important: you need to put #form="ngForm" on form element in template
     */
    @ViewChild('form', { static: false })
    form?: NgForm;

    /**
     * Create account data
     */
    registrationData: Nexus.Api.Customer.Register.RequestByOrder = {
        password: '',
        order: true
    };

    /**
     * Location service
     */
    protected router = inject(Router);

    /**
     * Auth service
     */
    protected requestService = inject(RequestService);

    protected events = inject(Events);

    /**
     * Create account status
     */
    status = new Status();

    constructor(
        activatedRoute: ActivatedRoute,
        protected changeDetectorRef: ChangeDetectorRef,
        private app: App
    ) {
        // take backend data
        this.data = activatedRoute.snapshot.data['checkoutSuccessData'];
        this.subscriptions.add(this.status.subscribe(() => this.changeDetectorRef.detectChanges()));
    }

    /**
     * Validate data on init, redirect to basket on failure
     */
    ngOnInit() {
        if (!this.data || (!this.orderNumber && !this.orderNumbers)) {
            this.router.navigateByUrl(routeOverride('/basket'));
        } else if (this.data.tracking) {
            this.events.broadcast(Checkout.EVENTS.SuccessTracking, this.data);
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * If client can create account
     */
    get canRegister(): boolean {
        return !!(this.data && this.data.customer && this.data.customer.can_register && !this.app.customer.model.isLoggedIn);
    }

    /**
     * Order number shorthand
     */
    get orderNumber(): string | undefined {
        return this.data.number;
    }

    /**
     * Order numbers shorthand
     */
    get orderNumbers(): string[] | undefined {
        return this.data.numbers ? (!Array.isArray(this.data.numbers) ? [this.data.numbers] : this.data.numbers) : undefined;
    }

    /**
     * If its multishipping order check
     */
    get isMultishipping(): boolean {
        return !!this.data.numbers;
    }

    register(): void {
        this.requestService.submitForm(
            this.form,
            this.status,
            () => this.requestService.nexus.customer.register(this.registrationData),
            () => this.onRegister()
        );
    }

    protected onRegister() {}

    trackByOrderNumber(index: number, orderNumber: string): string {
        return orderNumber;
    }
}
